export const IS_LOCAL = false;

export const PRODUCTION_FRONTEND_URL  = "https://codmarket.elaatmani.com/";
export const PRODUCTION_BACKEND_URL   = "https://codmarket-api.elaatmani.com/";

export const DEVELOPMENT_FRONTEND_URL = "http://localhost:8080/";
export const DEVELOPMENT_BACKEND_URL  = "http://localhost:8000/";
export const NAWRIS_URL               = "https://portal.nawris.algoriza.com/";
export const DIGYLOG_URL              = "";
export const PREFIX                   = "cod_";
export const DEFAULT_LANGUAGE         = "en";
export const CURRENCY                 = "MAD";
export const APP_NAME                 = "COD Market";

export const FRONTEND_URL = IS_LOCAL ? DEVELOPMENT_FRONTEND_URL : PRODUCTION_FRONTEND_URL;
export const BACKEND_URL  = IS_LOCAL ? DEVELOPMENT_BACKEND_URL  : PRODUCTION_BACKEND_URL;